import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    // read the input text and convert into a readable date
    if (typeof value === 'string' && value.indexOf('/') > -1) {
      const str = value.split('/');

      let year: number;
      if (str[2]?.length === 2 && parseInt(str[2], 10) > 29) {
        year = Number(`19${str[2]}`);
      } else if (str[2]?.length === 2) {
        year = Number(`20${str[2]}`);
      } else {
        // they've entered a 4 digit date
        year = Number(str[2]);
      }

      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return new Date(year, month, date);
    }

    const timestamp =
      typeof value === 'number' ? value : Date.parse(value as string);

    return Number.isNaN(timestamp) ? null : new Date(timestamp);
  }

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'input') {
      // format the date text to place in the input box
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${this.to2digit(day)}/${this.to2digit(month)}/${year}`;
    }
    if (displayFormat === 'inputMonth') {
      // format the date to show on the monthYearLabel above the calendar
      const month = date.toLocaleString(undefined, { month: 'short' });
      const year = date.getFullYear();

      return `${month} ${year}`;
    }
    return date.toDateString();
  }

  private to2digit(n: number): string {
    return `00${n}`.slice(-2);
  }
}

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'inputMonth',
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
